import { render } from "./Archives.vue?vue&type=template&id=068a9d56"
import script from "./Archives.vue?vue&type=script&lang=js"
export * from "./Archives.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/userSupport/Archives.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "068a9d56"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('068a9d56', __exports__)) {
    api.reload('068a9d56', __exports__)
  }
  
  module.hot.accept("./Archives.vue?vue&type=template&id=068a9d56", () => {
    api.rerender('068a9d56', render)
  })

}


export default __exports__